import http from '../assets/jslibs/axios/http';

//获取用户钱包信息
export const getMyWallet = function() {
	return http.get('/v1/app/Wallet');
}

//获取用户钱包明细列表
export const getBalanceRecord = function(data) {
	return http.get('/v1/app/UserBalanceRecord', data);
}

//获取充值档次列表
export const getRechargeClassList = function() {
	return http.get('/v1/app/Recharge');
}

//充值
export const postRecharge = function(data) {
	return http.post('/v1/app/Recharge',data);
}

//获取充值状态
export const getChargeStatus = function(data) {
	return http.get(`/v1/app/Recharge/${data}`);
}

//获取业务员提现记录
export const gertUserWithdrawal = function(data) {
	return http.get('/v1/app/UserWithdrawal',data);
}




//新增银行卡
export const addNewCard = function(data) {
	return http.post('/v1/app/UserBankCard', data);
}

//获取银行卡列表
export const getCardList = function() {
	return http.get('/v1/app/UserBankCard');
}

//删除银行卡
export const deleteCard = function(uuid) {
	return http.delete(`/v1/app/UserBankCard/${uuid}`);
}

//提现
export const withdrawBalance = function(data) {
	return http.post('/v1/app/UserWithdrawal', data);
}